export const rolesConstants = {
	GET_ROLES_REQUEST: "ROLES_GET_ROLES_REQUEST",
	GET_ROLES_SUCCESS: "ROLES_GET_ROLES_SUCCESS",
	GET_ROLES_FAILURE: "ROLES_GET_ROLES_FAILURE",
};
